/**
 * Firebase configuration
 * This file contains all Firebase related configuration
 */

export const firebaseConfig = {
  apiKey: "AIzaSyDP-asmrOzd56Kro-hUYGqwvuEXgf3WtXY",
  authDomain: "wingmancoza.firebaseapp.com",
  projectId: "wingmancoza",
  storageBucket: "wingmancoza.firebasestorage.app",
  messagingSenderId: "778264646788",
  appId: "1:778264646788:web:7584248a55e1487e879ed1",
  measurementId: "G-WJR04RMFRF"
};